import * as CoreFns from '../utilities/CoreFns';
import * as FormSet from './FormSet';

function App(props) {

  var organicChanges = props.organicChanges;
  var currentList = props.currentList;
  var error = props.error;
  var userNos = props.userNos;
  var questions = props.questions;
  var header = props.header;
  var justTakeFirstQuestion = props.justTakeFirstQuestion;
  var addToExtraScreen = props.addToExtraScreen;
  var leftColRefs = props.leftColRefs;
  var setLeftColRefs = props.setLeftColRefs;

  var containerClass = 'container-fluid py-5';
//

  var startPt = CoreFns.goDownPath(currentList, header);
  var depth = 1;
  if (justTakeFirstQuestion){
    depth = 0;
  }
  var ans = FormSet.doForm(questions, header, startPt, depth, currentList, userNos, organicChanges, error, addToExtraScreen, leftColRefs, setLeftColRefs);
  if (justTakeFirstQuestion){
    return ans[0];
  }else{
    return <div className={containerClass} >{ans}</div>
  }
}
//


export default App;
